




































































import { Component, Vue } from 'vue-property-decorator';
import WebApiMessage from '@/core/messages/WebApiMessage.vue';
import Api from '@/project/http/Api.service';
import passwordService from '@/project/form/custom-rules/password';
import PasswordCondition from '@/project/auth/PasswordCondition.vue';
import { ChangePasswordRequest } from '@/types/apiServerContract';
import impersonationStore from '@/project/shared/impersonation/impersonation.service';

@Component({
    components: { PasswordCondition, WebApiMessage }
})
export default class ChangePasswordPanel extends Vue {
    password: string = '';
    newPassword: string = '';
    newPasswordConfirm: string = '';
    done = false;
    busy = false;

    get hasLength(): boolean {
        return passwordService.hasLength(this.newPassword);
    }

    get hasNumeric() {
        return passwordService.hasNumeric(this.newPassword);
    }

    get hasUppercase() {
        return passwordService.hasUppercase(this.newPassword);
    }

    get hasLowercase() {
        return passwordService.hasLowercase(this.newPassword);
    }

    get hasSpecialChar() {
        return passwordService.hasSpecialChar(this.newPassword);
    }

    get isImpersonating(): boolean {
        return impersonationStore.isImpersonating;
    }

    get oldPasswordIsNeeded(): boolean {
        return !this.isImpersonating;
    }

    close() {
        this.$emit('close');
    }

    async submit() {
        try {
            this.busy = true;
            await Api.authentication.changePassword({
                oldPassword: this.password,
                newPassword: this.newPassword,
                confirmNewPassword: this.newPasswordConfirm
            } as ChangePasswordRequest, 'changepassword');
            this.done = true;
        } catch (err) {
            // Ok, validation-messages will be shown
        } finally {
            this.busy = false;
        }
    }
}
